// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, IsBoolean, IsInt, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { DomainApiModel } from '../../../../types/models/domain.model';
import { FeatureTypeApiModel } from '../../../../types/models/feature-type.model';
import { LayerApiModel } from '../../../../types/models/layer.model';
import { SymbolApiModel } from '../../../../types/models/symbol.model';

class DomainForm implements Pick<DomainApiModel, keyof DomainForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;

  @IsString()
  shortName: string;
}

class FeatureTypeForm implements Pick<FeatureTypeApiModel, keyof FeatureTypeForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

class LayerForm implements Pick<LayerApiModel, keyof LayerForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

class SymbolForm implements Pick<SymbolApiModel, keyof SymbolForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

export class SurveyCodeForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  description: string;

  @IsBoolean()
  includeInSurface: boolean;

  @IsArray()
  @ValidateNested({ each: true })
  domains: DomainForm[];

  @ValidateNested()
  featureType: FeatureTypeForm;

  @IsOptional()
  @ValidateNested()
  pointLayer?: LayerForm;

  @IsOptional()
  @ValidateNested()
  breaklineLayer?: LayerForm;

  @IsOptional()
  @ValidateNested()
  symbol?: SymbolForm;
}
